import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id AEA5545F-4C74-4A14-8F9E-92CC258216AD
 * name format-horizontal-align-left
 * version: 1.6.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/format-horizontal-align-left.svg
 * tags
 * - Text / Content / Format 
 */
export const FormatHorizontalAlignLeftIcon = createSvgIcon(<><path d="M11,16V13H21V11H11V8L7,12L11,16M3,20H5V4H3V20Z" /></>, 'FormatHorizontalAlignLeftIcon');
export default FormatHorizontalAlignLeftIcon